"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePaginationLoadable = void 0;

var react_1 = __importDefault(require("react"));

var _1 = require(".");

var utility_1 = require("../utility");

var usePaginationLoadable = function usePaginationLoadable(input) {
  var analyticsHook = (0, _1.useAnalytics)();

  var _ref = (0, _1.useFilters)(),
      filterStack = _ref.filterStack;

  var hasMore = input.resultStats.displayedResults !== input.resultStats.numberOfResults;
  var handleLoadMore = react_1.default.useCallback(function () {
    utility_1.debug.log("usePaginationLoadable", "handleLoadMore");

    if (!hasMore) {
      return;
    }

    input.loadMore();
    analyticsHook.track({
      eventName: "paginationChange",
      payload: {
        page: Math.ceil(input.resultStats.displayedResults / ((filterStack === null || filterStack === void 0 ? void 0 : filterStack.pageSize) || 20)) + 1,
        source: window.location.pathname.includes("/search") ? "search" : "collection"
      }
    });
  }, [input.loadMore, analyticsHook.track, input.resultStats, filterStack]);
  return react_1.default.useMemo(function () {
    return {
      loading: input.loading,
      hasMore: hasMore,
      handleLoadMore: handleLoadMore,
      resultStats: input.resultStats
    };
  }, [input.loading, hasMore, handleLoadMore, input.resultStats]);
};

exports.usePaginationLoadable = usePaginationLoadable;